export default "__VITE_ASSET__Dmkth8Mi__"